export default __webpack_public_path__ + "4c78cddc643b67ddde6f1a2debd4eb53.svg";